import { useFeatureAccessInsights, useFeatureAccessInsightsStatus } from '@ms/yammer-hooks/dist/featureAccessInsights';

import type { UseUIFeatureCheck } from '../types';

export {
  useIsCampaignsEntryPointVisible as useIsInsightsCampaignEnabled,
  useIsLeadersInsightsEntryPointVisible as useIsInsightsLeadersOrgNavigationEnabled,
  useIsMyInsightsEntryPointVisible as useIsInsightsLeadersMyInsightsNavigationEnabled,
  useIsQnAOrgEntryPointVisible as useIsInsightsQnAOrgEnabled,
} from '@ms/yammer-hooks/dist/insights';

const useInsightsLeadersPrerequisites: UseUIFeatureCheck<[], boolean | undefined> = () => {
  const featureAccessInsightsStatus = useFeatureAccessInsightsStatus();

  if (featureAccessInsightsStatus === 'pending') {
    return undefined;
  }

  return true;
};

/**
 * @deprecated `@ms/yammer-web-ui-features` is a monolithic package which adds bloat from all feature access settings
 * to a single bootstrap API call (FeatureAccessSettingsClients) and JS assets. DO NOT add new code to this package.
 * Your team is responsible for migrating fields and code out of this package as you move your features to Relay, where
 * your feature should request the necessary `viewerCanXX` fields in its own colocated fragment. Note that we may also
 * need to design a new scalable permissions-check solution for features which require additional logic to check access.
 */
export const useIsPremiumCommunityInsightsV2Enabled: UseUIFeatureCheck<[], boolean | undefined> = () => {
  const featureAccessInsights = useFeatureAccessInsights();
  const insightsLeadersPrerequisites = useInsightsLeadersPrerequisites();
  const canViewActivity = featureAccessInsights?.canViewActivity === true;

  return insightsLeadersPrerequisites && canViewActivity;
};
